import { StateCreator } from "zustand";

import { StoreT } from "./store";

export type MyselfSliceT = IState & IActions;

interface IState {
	contactID: string;
	stayLogged: boolean;
	loggedIn: boolean;
	token: string | undefined;
	ucsid: string | undefined;
	ucserveruri: string | undefined;
	lastCustomNotes: string[];
	cookiesAccepted: boolean;
}

interface IActions {
	setMySelfIsLogged: (loggedIn: boolean) => void;
	setMySelfUCSID: (ucsid: string) => void;
	setMySelfUCServerURI: (ucserveruri: string) => void;
	setMySelfToken: (token: string | undefined) => void;
	setMySelfStayLogged: (stayLogged: boolean) => void;
}

export const initialState = {
	contactID: "",
	stayLogged: false,
	loggedIn: false,
	token: undefined,
	ucsid: undefined,
	ucserveruri: undefined,
	lastCustomNotes: [],
	cookiesAccepted: false
};

export const createMyselfSlice: StateCreator<
	StoreT,
	[["zustand/devtools", never], ["zustand/subscribeWithSelector", never]],
	[],
	MyselfSliceT
> = (set) => ({
	...initialState,
	setMySelfIsLogged: (loggedIn: boolean) => {
		set(
			(prev) => ({
				...prev,
				loggedIn
			}),
			false,
			"setMySelfIsLogged"
		);
	},
	setMySelfUCSID: (ucsid: string) => {
		set(
			(prev) => ({
				...prev,
				ucsid
			}),
			false,
			"setMySelfUCSID"
		);
	},
	setMySelfUCServerURI: (ucserveruri: string) => {
		set(
			(prev) => ({
				...prev,
				ucserveruri
			}),
			false,
			"setMySelfUCServerURI"
		);
	},
	setMySelfToken: (token: string | undefined) => {
		set(
			(prev) => ({
				...prev,
				token
			}),
			false,
			"setMySelfToken"
		);
	},
	setMySelfStayLogged: (stayLogged: boolean) => {
		set(
			(prev) => ({
				...prev,
				stayLogged
			}),
			false,
			"setMySelfStayLogged"
		);
	}
});
